import { IMAGES } from "../lib/constants";
import SectionHeading from "../components/SectionHeading";
import SEO from "../components/SEO";

const CATEGORIES = [
  {
    id: "luxury",
    eyebrow: "Residenziale Luxury",
    title: "Impianti FTV su tetti di privati e ville di pregio",
    description:
      "Installazioni curate nell'estetica e nell'integrazione architettonica, dedicate a clientela residenziale di alto livello.",
    items: [
      { src: IMAGES.heroLuxury, alt: "Villa di lusso con impianto fotovoltaico" },
      { src: IMAGES.residential, alt: "Casa residenziale con pannelli solari" },
      { src: IMAGES.villaWithPv, alt: "Villa moderna con FTV integrato" },
      { src: IMAGES.groundPv, alt: "Casa moderna con impianto solare" },
    ],
  },
  {
    id: "industrial",
    eyebrow: "Industriale e Tettoie",
    title: "Tetti industriali, capannoni e tettoie",
    description:
      "Grandi superfici di capannoni, tettoie e coperture metalliche convertite in centrali energetiche aziendali.",
    items: [
      { src: IMAGES.realCarportAerial1, alt: "Copertura industriale con pannelli fotovoltaici" },
      { src: IMAGES.realCarportAerial2, alt: "Impianto su tettoia metallica — vista dall'alto" },
      { src: IMAGES.realCarportSide, alt: "Tettoia in lamiera con pannelli FTV" },
      { src: IMAGES.industrialField, alt: "Impianto industriale con silos" },
    ],
  },
  {
    id: "ground",
    eyebrow: "Impianti a Terra",
    title: "Parchi fotovoltaici e impianti a terra",
    description:
      "Installazioni di grande scala su terreni agricoli e industriali con strutture di supporto dedicate.",
    items: [
      { src: IMAGES.groundField1, alt: "Vista aerea impianto fotovoltaico a terra" },
      { src: IMAGES.groundField2, alt: "Parco fotovoltaico in campo aperto" },
      { src: IMAGES.groundField3, alt: "Impianto solare in campo soleggiato" },
      { src: IMAGES.groundItaly, alt: "Impianto fotovoltaico a terra in Italia" },
      { src: IMAGES.groundAerial, alt: "Vista aerea pannelli su prato" },
      { src: IMAGES.groundTrackers, alt: "Trackers solari su campo verde" },
    ],
  },
  {
    id: "safety",
    eyebrow: "Sicurezza in Quota",
    title: "I nostri tecnici al lavoro, in totale sicurezza",
    description:
      "Caschi protezione, imbragature DPI, formazione specifica per lavori in quota: la sicurezza non è negoziabile.",
    items: [
      { src: IMAGES.realRooftopWorkers1, alt: "Tecnici al lavoro su tetto in tegole" },
      { src: IMAGES.realRooftopWorkers2, alt: "Operatori con DPI durante l'installazione" },
      { src: IMAGES.realRooftopWorkers3, alt: "Montaggio in sicurezza dei pannelli" },
      { src: IMAGES.workerCarryPanel, alt: "Tecnico in sicurezza trasporta pannello solare" },
      { src: IMAGES.workerPPE, alt: "Elettricista con DPI su tetto" },
      { src: IMAGES.workerSafetyGear, alt: "Operaio con DPI installa pannelli solari" },
      { src: IMAGES.inspectorHardhat, alt: "Ispettore con casco e documenti sull'impianto" },
      { src: IMAGES.electricianDrill, alt: "Elettricista con casco e guanti installa pannello" },
      { src: IMAGES.orangeHardhat, alt: "Tecnico con casco arancione installa pannelli" },
      { src: IMAGES.twoWorkers, alt: "Due operai con DPI montano un impianto" },
      { src: IMAGES.workersInstall, alt: "Squadra di operai installa pannelli solari" },
      { src: IMAGES.rooftopInstall, alt: "Operai installano pannelli sul tetto" },
      { src: IMAGES.rooftopWorker, alt: "Tecnico sul tetto con pannello solare" },
    ],
  },
  {
    id: "cleaning",
    eyebrow: "Lavaggio Pannelli",
    title: "Pulizia e manutenzione professionale",
    description:
      "Lavaggio specializzato con acqua demineralizzata e spazzole rotanti dedicate per recuperare la massima resa energetica dei pannelli.",
    items: [
      { src: IMAGES.panelsCleaning, alt: "Squadra di tecnici lava pannelli solari sul tetto" },
      { src: IMAGES.cleaningTeam, alt: "Team di operatori durante il lavaggio professionale" },
      { src: IMAGES.cleaningBrush, alt: "Lavaggio pannelli con spazzola professionale" },
      { src: IMAGES.cleaningSingle, alt: "Operatore lava un pannello fotovoltaico" },
    ],
  },
  {
    id: "renovation",
    eyebrow: "Edilizia & Ristrutturazioni",
    title: "Case in rifacimento e lavori edili",
    description:
      "Oltre al fotovoltaico, accompagniamo i clienti negli interventi di ristrutturazione edile della casa.",
    items: [
      { src: IMAGES.renovation, alt: "Edificio residenziale in ristrutturazione con ponteggio" },
      { src: IMAGES.renovationScaffold, alt: "Operai al lavoro su edificio in ristrutturazione" },
      { src: IMAGES.renovationModern, alt: "Operaio con casco lavora sulla facciata" },
      { src: IMAGES.renovationHouse, alt: "Cantiere di ristrutturazione con ponteggio e attrezzi" },
      { src: IMAGES.renovationFacade, alt: "Operai su ponteggio rifanno una facciata storica" },
      { src: IMAGES.renovationInterior, alt: "Ristrutturazione interna abitazione" },
    ],
  },
];

export default function Gallery() {
  return (
    <div data-testid="page-gallery">
      <SEO
        title="Gallery — Progetti Realizzati"
        description="Portfolio di impianti fotovoltaici installati: residenziali luxury, capannoni industriali, parchi a terra, interventi di manutenzione, lavaggio pannelli ed edilizia."
        path="/gallery"
        image={IMAGES.groundField1}
      />

      {/* HERO */}
      <section className="relative h-[45vh] min-h-[340px] flex items-end overflow-hidden">
        <img src={IMAGES.groundField1} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 hero-overlay" />
        <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 lg:px-12 pb-14 w-full">
          <div className="flex items-center gap-3 mb-4">
            <span className="accent-line" />
            <span className="text-xs uppercase tracking-[0.3em] text-[#FED7AA]">Portfolio</span>
          </div>
          <h1 className="font-serif text-white text-4xl md:text-6xl leading-tight max-w-3xl">
            I nostri <span className="italic text-[#FED7AA]">progetti</span> in immagini.
          </h1>
        </div>
      </section>

      {/* CATEGORY ANCHORS */}
      <section className="sticky top-20 z-30 bg-white/85 backdrop-blur-xl border-b border-[#E5E7EB]">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
          <nav className="flex gap-2 overflow-x-auto py-4 no-scrollbar">
            {CATEGORIES.map((c) => (
              <a
                key={c.id}
                href={`#${c.id}`}
                data-testid={`gallery-anchor-${c.id}`}
                className="flex-shrink-0 px-4 py-2 rounded-full text-sm border border-[#E5E7EB] text-[#0F5132] hover:bg-[#0F5132] hover:text-white transition-colors"
              >
                {c.eyebrow}
              </a>
            ))}
          </nav>
        </div>
      </section>

      {/* CATEGORY SECTIONS */}
      {CATEGORIES.map((cat, ci) => (
        <section
          key={cat.id}
          id={cat.id}
          className={`py-16 md:py-24 scroll-mt-40 ${ci % 2 === 0 ? "bg-[#FAFAFA]" : "bg-white"}`}
          data-testid={`gallery-section-${cat.id}`}
        >
          <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
            <SectionHeading
              eyebrow={cat.eyebrow}
              title={cat.title}
              description={cat.description}
            />

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              {cat.items.map((it, i) => (
                <figure
                  key={i}
                  data-testid={`gallery-${cat.id}-${i}`}
                  className="group relative overflow-hidden rounded-2xl aspect-[4/3] bg-[#0F5132]"
                >
                  <img
                    src={it.src}
                    alt={it.alt}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                  <figcaption className="absolute bottom-0 left-0 right-0 p-4 text-white text-sm opacity-0 group-hover:opacity-100 transition-opacity">
                    {it.alt}
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </section>
      ))}
    </div>
  );
}
